import { toAppDate } from '@macs-frontend/core/utils/date';
import { Ratesheet } from '../models/ratesheet.model';

export const emptyRatesheet: Ratesheet = {
  // @ts-expect-error
  uuid: null,
  // @ts-expect-error
  name: null,
  // @ts-expect-error
  createdBy: null,
  estimates: [],
  invoices: [],
  // @ts-expect-error
  status: null,
  // @ts-expect-error
  usedIn: null,
  // @ts-expect-error
  projectType: null,
  ratesheetValues: [],
  fromDate: toAppDate('2000-01-01'),
  toDate: toAppDate('2000-12-31'),
};
